import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6ece5a71&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=6ece5a71&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece5a71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ece5a71')) {
      api.createRecord('6ece5a71', component.options)
    } else {
      api.reload('6ece5a71', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=6ece5a71&scoped=true", function () {
      api.rerender('6ece5a71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/change-target-number/List.vue"
export default component.exports